import React, { useEffect, useState } from 'react';
import { View, Text, TextInput, TouchableOpacity, StyleSheet } from 'react-native';
import { Modal, Select, MenuItem, FormControl } from '@material-ui/core';

const GuarantorForm = (props) => {
  const { onClose, showModal, data, onSave } = props;

  const [form, setForm] = useState({
    title: '',
    firstName: '',
    lastName: '',
    email: '',
    contactNumber: '',
    postcode: '',
    address: '',
  });

  const [errors, setErrors] = useState({});

  const handleChange = (name, value) => {
    if (name === "contactNumber") {
      setForm({ ...form, [name]: value.replace(/[^0-9]/g, '') });
    } else {
      setForm({ ...form, [name]: value });
    }
    setErrors({ ...errors, [name]: '' });
  };

  useEffect(() => {
    if (data?.isEdit && data?.open_flow_guarantor?.email) {
      setForm({
        title: data.open_flow_guarantor.title || "",
        firstName: data.open_flow_guarantor.first_name || "",
        lastName: data.open_flow_guarantor.last_name || "",
        email: data.open_flow_guarantor.email || "",
        contactNumber: data.open_flow_guarantor.number || "",
        postcode: data.open_flow_guarantor.post_code || "",
        address: data.open_flow_guarantor.correspondece_address || "",
        isEdit: true
      });
    }
  }, [data?.isEdit, data?.open_flow_guarantor]);

  const validateForm = () => {
    let newErrors = {};
    const mandatoryFields = ['title', 'firstName', 'lastName', 'email', 'address'];

    mandatoryFields.forEach((key) => {
      if (!form[key]) {
        newErrors[key] = `${key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1').toLowerCase()} is mandatory`;
      }
    });

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (form.email && !emailRegex.test(form.email)) {
      newErrors.email = 'Invalid email format';
    }

    if (!form.contactNumber) {
      newErrors.contactNumber = "Contact number is required";
    } else if (form.contactNumber.length <= 7) {
      newErrors.contactNumber = "Contact number must be more than 7 digits";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      console.log('Form data:', form);
      onSave(form);
    }
  };

  const fields = [
    { label: 'Title', name: 'title', type: 'select', options: ['Mr', 'Mrs', 'Miss', 'Ms', 'Dr'] },
    { label: 'First Name', name: 'firstName' },
    { label: 'Last Name', name: 'lastName' },
    { label: 'Email', name: 'email' },
    { label: 'Contact Number', name: 'contactNumber' },
    { label: 'Postcode', name: 'postcode' },
    { label: 'Address', name: 'address' },
  ];

  return (
    <Modal
      open={showModal || false}
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingLeft: 10,
        paddingRight: 10,
      }}
    >
      <View style={styles.container}>
        <Text style={styles.title}>Guarantor for {data?.tenName || ""}</Text>

        {fields.map(({ label, name, type, options }) => (
          <View key={name} style={styles.inputContainer}>
            <Text style={{ marginBottom: 8 }}>{label}</Text>
            {type === 'select' ? (
              <FormControl variant="outlined" fullWidth size="small" style={{ backgroundColor: '#fff' }}>
                <Select
                  value={form[name] || ''}
                  onChange={(e) => handleChange(name, e.target.value)}
                  displayEmpty
                  style={{ height: 40 }}
                >
                  <MenuItem value="" disabled>Select {label}</MenuItem>
                  {options.map((opt) => (
                    <MenuItem key={opt} value={opt}>{opt}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            ) : (
              <TextInput
                placeholder={label}
                placeholderTextColor="#999"
                value={form[name] || ''}
                style={[styles.input, errors[name] && styles.inputError]}
                onChangeText={(value) => handleChange(name, value)}
              />
            )}
            {errors[name] && <Text style={styles.errorText}>{errors[name]}</Text>}
          </View>
        ))}

        <View style={styles.buttonContainer}>
          <TouchableOpacity
            onPress={() => {
              setForm({
                title: '',
                firstName: '',
                lastName: '',
                email: '',
                contactNumber: '',
                postcode: '',
                address: '',
              });
              onClose();
            }}
            style={styles.cancelButton}
          >
            <Text style={styles.buttonText}>Cancel</Text>
          </TouchableOpacity>

          <TouchableOpacity style={styles.saveButton} onPress={handleSubmit}>
            <Text style={styles.buttonText}>Save</Text>
          </TouchableOpacity>
        </View>
      </View>
    </Modal>
  );
};

const styles = StyleSheet.create({
  container: {
    padding: 40,
    backgroundColor: 'white',
    borderRadius: 10,
    shadowColor: '#000',
    shadowOpacity: 0.2,
    shadowRadius: 5,
    elevation: 5,
    margin: 20,
    maxWidth: 600,
    width: '100%',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    marginBottom: 20,
  },
  inputContainer: {
    marginBottom: 16,
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 10,
    height: 40,
  },
  inputError: {
    borderColor: 'red',
  },
  errorText: {
    color: 'red',
    fontSize: 12,
    marginTop: 5,
  },
  buttonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  cancelButton: {
    backgroundColor: '#dc3545',
    padding: 10,
    borderRadius: 5,
    flex: 0.45,
    justifyContent: 'center',
    alignItems: 'center'
  },
  saveButton: {
    backgroundColor: '#6c63ff',
    padding: 10,
    borderRadius: 5,
    flex: 0.45,
    justifyContent: 'center',
    alignItems: 'center'
  },
  buttonText: {
    color: 'white',
    fontWeight: 'bold',
  },
});

export default GuarantorForm;
